/* =========================================
   THE SCHOOL DROP — SHOPIFY THEME JS
   ========================================= */

// ── COUNTDOWN TIMER ──
class AlmaCountdown {
  constructor(el) {
    this.el = el;
    this.target = new Date(el.dataset.target);
    this.dEl = el.querySelector('[data-cd="d"]');
    this.hEl = el.querySelector('[data-cd="h"]');
    this.mEl = el.querySelector('[data-cd="m"]');
    this.sEl = el.querySelector('[data-cd="s"]');
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }
  pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
  tick() {
    const diff = Math.max(0, this.target - new Date());
    if (this.dEl) this.dEl.textContent = this.pad(Math.floor(diff / 86400000));
    if (this.hEl) this.hEl.textContent = this.pad(Math.floor((diff % 86400000) / 3600000));
    if (this.mEl) this.mEl.textContent = this.pad(Math.floor((diff % 3600000) / 60000));
    if (this.sEl) this.sEl.textContent = this.pad(Math.floor((diff % 60000) / 1000));
    if (diff === 0) { clearInterval(this.interval); this.el.dispatchEvent(new Event('countdown:ended')); }
  }
}

// ── CART DRAWER ──
class AlmaCart {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.overlay = document.getElementById('CartOverlay');
    this.countEl = document.querySelectorAll('[data-cart-count]');
    this.bodyEl = document.getElementById('CartBody');
    this.subtotalEl = document.getElementById('CartSubtotal');
    this.checkoutBtn = document.getElementById('CartCheckout');
    if (!this.drawer) return;
    this.bindEvents();
    this.refresh();
  }

  bindEvents() {
    document.querySelectorAll('[data-cart-open]').forEach(btn =>
      btn.addEventListener('click', () => this.open()));
    this.overlay?.addEventListener('click', () => this.close());
    document.getElementById('CartClose')?.addEventListener('click', () => this.close());
    document.getElementById('CartContinue')?.addEventListener('click', () => this.close());
    document.addEventListener('keydown', e => e.key === 'Escape' && this.close());
  }

  open() {
    this.drawer.classList.add('open');
    this.overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    this.drawer.classList.remove('open');
    this.overlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  async refresh() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    this.updateCount(cart.item_count);
    this.renderItems(cart);
  }

  updateCount(n) {
    this.countEl.forEach(el => {
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
    });
  }

  renderItems(cart) {
    if (!this.bodyEl) return;
    if (cart.item_count === 0) {
      this.bodyEl.innerHTML = '<div class="cart-drawer__empty">Your bag is empty.</div>';
      if (this.subtotalEl) this.subtotalEl.textContent = '$0.00';
      if (this.checkoutBtn) this.checkoutBtn.setAttribute('disabled', '');
      return;
    }
    if (this.checkoutBtn) this.checkoutBtn.removeAttribute('disabled');
    this.bodyEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <div class="cart-item__img">
          ${item.featured_image ? `<img src="${item.featured_image.url}" alt="${item.title}" loading="lazy">` : ''}
        </div>
        <div class="cart-item__details">
          <p class="cart-item__title">${item.product_title}</p>
          <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
          <div class="cart-item__price-row">
            <div class="cart-item__qty">
              <button class="cart-item__qty-btn" data-qty-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
              <span class="cart-item__qty-num">${item.quantity}</span>
              <button class="cart-item__qty-btn" data-qty-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
            </div>
            <span class="cart-item__price">${this.formatMoney(item.final_line_price)}</span>
          </div>
          <button class="cart-item__remove" data-remove-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    this.bodyEl.querySelectorAll('[data-remove-key]').forEach(btn =>
      btn.addEventListener('click', () => this.removeItem(btn.dataset.removeKey)));

    this.bodyEl.querySelectorAll('[data-qty-key]').forEach(btn =>
      btn.addEventListener('click', () => this.updateQty(btn.dataset.qtyKey, parseInt(btn.dataset.qty))));

    if (this.subtotalEl)
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
  }

  async removeItem(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    this.refresh();
  }

  async updateQty(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    });
    this.refresh();
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
}

// ── SIZE SELECTOR ──
class SizeSelector {
  constructor(form) {
    this.form = form;
    this.btns = form.querySelectorAll('.size-btn');
    this.input = form.querySelector('[name="id"]');
    this.addBtn = form.querySelector('[data-add-to-cart]');
    this.btns.forEach(btn => btn.addEventListener('click', () => this.select(btn)));
  }
  select(btn) {
    if (btn.disabled) return;
    this.btns.forEach(b => b.setAttribute('aria-selected', 'false'));
    btn.setAttribute('aria-selected', 'true');
    if (this.input) this.input.value = btn.dataset.variantId;
    if (this.addBtn) this.addBtn.removeAttribute('disabled');
  }
}

// ── ADD TO CART ──
class AddToCart {
  constructor(form) {
    this.form = form;
    this.btn = form.querySelector('[data-add-to-cart]');
    this.originalText = this.btn?.textContent || 'Add to Bag';
    form.addEventListener('submit', e => this.handle(e));
  }

  async handle(e) {
    e.preventDefault();
    if (!this.btn) return;
    // Read from checked radio button (native form input)
    const checkedRadio = this.form.querySelector('[name="id"]:checked');
    const variantId = checkedRadio?.value;
    if (!variantId) {
      this.flash('Select a size first');
      return;
    }
    this.setLoading(true);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.description || 'Could not add to bag');
      }
      this.setLoading(false);
      this.setSuccess();
      window.almaCart?.open();
      window.almaCart?.refresh();
    } catch (err) {
      this.setLoading(false);
      this.flash(err.message || 'Something went wrong');
    }
  }

  setLoading(on) {
    this.btn.disabled = on;
    this.btn.textContent = on ? 'Adding...' : this.originalText;
  }

  setSuccess() {
    this.btn.textContent = '✓ Added to Bag';
    this.btn.style.background = '#2e7d32';
    this.btn.style.color = 'white';
    setTimeout(() => {
      this.btn.textContent = this.originalText;
      this.btn.style.background = '';
      this.btn.style.color = '';
    }, 2200);
  }

  flash(msg) {
    const prev = this.btn.textContent;
    this.btn.textContent = msg;
    setTimeout(() => this.btn.textContent = prev, 2500);
  }
}

// ── WAITLIST FORM ──
class WaitlistForm {
  constructor(form) {
    this.form = form;
    this.btn = form.querySelector('[data-waitlist-submit]');
    this.select = form.querySelector('select');
    this.select?.addEventListener('change', () => this.select.classList.add('filled'));
    form.addEventListener('submit', e => this.handle(e));
  }

  async handle(e) {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(this.form));
    const isAmbassador = data.interest === 'ambassador';
    this.btn.textContent = 'Submitting...';
    this.btn.disabled = true;

    try {
      // POST to Klaviyo via your backend or Shopify Flow webhook
      // Replace with your actual Klaviyo list ID endpoint
      await fetch('/a/klaviyo/identify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: data.email,
          properties: {
            '$first_name': data.name?.split(' ')[0],
            '$last_name': data.name?.split(' ').slice(1).join(' '),
            '$phone_number': data.phone,
            'School': data.school,
            'Interest': data.interest,
            'Ambassador': isAmbassador,
            'Source': 'The School Drop Waitlist Form'
          }
        })
      });
    } catch (_) { /* non-blocking — continue to success state */ }

    this.btn.textContent = isAmbassador
      ? "✓ Application received — we'll be in touch"
      : "✓ You're on the list";
    this.btn.style.background = '#2e7d32';
    this.btn.style.color = 'white';

    setTimeout(() => {
      this.form.reset();
      this.select?.classList.remove('filled');
      this.btn.textContent = 'Secure My Spot →';
      this.btn.style.background = '';
      this.btn.style.color = '';
      this.btn.disabled = false;
    }, 3500);
  }
}

// ── SCROLL REVEAL ──
class ScrollReveal {
  constructor() {
    this.obs = new IntersectionObserver(entries => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), i * 80);
        }
      });
    }, { threshold: 0.07 });
    document.querySelectorAll('.reveal').forEach(el => this.obs.observe(el));
  }
}

// ── INIT ──
document.addEventListener('DOMContentLoaded', () => {
  // Cart
  window.almaCart = new AlmaCart();

  // Countdowns
  document.querySelectorAll('[data-countdown]').forEach(el => new AlmaCountdown(el));

  // Product forms
  document.querySelectorAll('[data-product-form]').forEach(form => {
    new SizeSelector(form);
    new AddToCart(form);
  });

  // Waitlist forms
  document.querySelectorAll('[data-waitlist-form]').forEach(form => new WaitlistForm(form));

  // Scroll reveal
  new ScrollReveal();

  // Mobile nav toggle
  document.getElementById('NavToggle')?.addEventListener('click', () => {
    document.getElementById('MobileNav')?.classList.toggle('open');
  });

  // Header "Find Your School" link — open drawer if on shop page, else navigate
  document.querySelectorAll('[data-open-school-drawer]').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var drawer = document.getElementById('school-drawer');
      var overlay = document.getElementById('drawer-overlay');
      if (drawer && overlay) {
        drawer.classList.add('open');
        overlay.classList.add('open');
      } else {
        window.location.href = '/pages/shop';
      }
    });
  });
});
